import { FieldsEnum, RenewalChangedAddressEnum } from 'app/shared/enums';
import { zipCodeChange } from 'app/services/businessFunctions/helpers/zipCodeChange';
import { addRenewalChangedAddress } from 'app/shared/helpers/addRenewalChangedAddress';

const firstCoownerAddressDetails = {
  coowners1LegalAddressZipCodeChange(initialRun: boolean) {
    addRenewalChangedAddress(
      initialRun,
      RenewalChangedAddressEnum.Coowner1Legal
    );

    zipCodeChange(initialRun, FieldsEnum.Coowners1LegalAddressZipCode);
  },

  coowners1LegalAddressCityChange(initialRun: boolean) {
    addRenewalChangedAddress(
      initialRun,
      RenewalChangedAddressEnum.Coowner1Legal
    );
  },
};

export default firstCoownerAddressDetails;
